import { z } from 'zod';

/** Provider-agnostic staff row for AI availability read layer. */
export const availabilityStaffSchema = z
  .object({
    externalId: z.string().min(1).max(64),
    displayName: z.string().min(1).max(200),
  })
  .strict();

export type AvailabilityStaff = z.infer<typeof availabilityStaffSchema>;

/** Provider-agnostic slot row — UTC ISO start time only. */
export const availabilitySlotSchema = z
  .object({
    startAt: z.string().datetime(),
  })
  .strict();

export type AvailabilitySlot = z.infer<typeof availabilitySlotSchema>;

export const listAvailabilityStaffInputSchema = z
  .object({
    bookingProvider: z.string().min(1).max(32),
    locationId: z.string().min(1).max(64),
    serviceExternalId: z.string().min(1).max(64),
  })
  .strict();

export type ListAvailabilityStaffInput = z.infer<typeof listAvailabilityStaffInputSchema>;

export const listAvailabilitySlotsInputSchema = z
  .object({
    bookingProvider: z.string().min(1).max(32),
    locationId: z.string().min(1).max(64),
    serviceExternalId: z.string().min(1).max(64),
    staffExternalId: z.string().min(1).max(64),
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  })
  .strict();

export type ListAvailabilitySlotsInput = z.infer<typeof listAvailabilitySlotsInputSchema>;

export const listAvailabilityDatesInputSchema = z
  .object({
    bookingProvider: z.string().min(1).max(32),
    locationId: z.string().min(1).max(64),
    serviceExternalId: z.string().min(1).max(64),
    staffExternalId: z.string().min(1).max(64),
  })
  .strict();

export type ListAvailabilityDatesInput = z.infer<typeof listAvailabilityDatesInputSchema>;

/**
 * Universal read-only availability port for external booking providers.
 * Distinct from session-scoped `AvailabilityPort` in ports.ts (MiniBook schedule).
 */
export interface ProviderAvailabilityPort {
  listStaff(input: ListAvailabilityStaffInput): Promise<AvailabilityStaff[]>;
  listDates(input: ListAvailabilityDatesInput): Promise<string[]>;
  listSlots(input: ListAvailabilitySlotsInput): Promise<AvailabilitySlot[]>;
}
